import { createActionConfig } from './create-action-config';

export const type = '@appcues/continue';
export const getContinue = config =>
  createActionConfig({
    type,
    config,
  });
